import React, { Fragment } from 'react'
import Blocks from '../blocks/_Blocks'

const BodyBlocks = ({ body, name }) => {
  //console.table(body)
  return (
    <div>
      {body &&
        body.map((block, index) => (
          <Fragment key={index}>
            <span id={block._uid}></span>
            {React.createElement(Blocks(block.component), {
              key: block._uid,
              block: block,
              type: block.component,
              name: name,
            })}
          </Fragment>
        ))}
    </div>
  )
}
export default BodyBlocks
